import React, {useContext, useEffect} from 'react';
import HotspotContext from '../../../context/HotspotContext';
import UserContext from '../../../context/UserContext';


const LoginPage = () => {
    const { request, vendor } = useContext(HotspotContext)
    const user = useContext(UserContext)

    useEffect(() =>{
        // console.log(request, vendor, user)
        
    },[])

    return <div>Ожидание ответа Hotspot</div>
}

export default LoginPage